import { safeatob } from '@web3auth/auth';

function decodeToken(token) {
  const [header, payload] = token.split(".");
  return {
    header: JSON.parse(safeatob(header)),
    payload: JSON.parse(safeatob(payload))
  };
}

export { decodeToken };
